import React from 'react';
import Immutable from 'immutable';
import styled from 'styled-components';
import { defaultTheme } from '../../data/themes';
import { getErrorMessages, getErrorType } from '../../data/validation';

const ErrorWrapper = styled.div`
	color: ${props => props.theme.errorColor || defaultTheme.errorColor};
	text-align: center;

	[data-type=warning] {
		color: ${props => props.theme.warningColor || defaultTheme.warningColor};
	}
`;

export default class Error extends React.PureComponent {
	render() {
		let type = getErrorType(this.props.error);
		if (!type) {
			return null;
		}
		let messages = getErrorMessages(this.props.error);
		return (
			<ErrorWrapper className="ps-error" data-type={type}>
				{
					messages.map((message, index) => {
						return (
							<div key={index}>
								{message}
							</div>
						)
					})
				}
			</ErrorWrapper>
		)
	}
}

